import {
  createCornerGuidelineInfo,
  createCornerGuidelines,
  removeGuideLines,
  updateGuideLines,
  updateGuideLinesInfo,
} from "./createGuidelines";
import { sendMoveToMerchant } from "../../utils/sendMoveToMerchant";
import { updateCornerBoxes } from "./createCornerBoxes";
// import { getCloseBounds, removeRelativeBounds } from "./relativeBounds";
import { WidgetConfig } from "../Widget/Widget";

export const onMouseOverMove = (
  e: MouseEvent,
  invisibleLayer: any,
  isEditMode: boolean
) => {
  if (isEditMode && invisibleLayer) {
    invisibleLayer.style.cursor = "move";
  } else if (invisibleLayer) {
    invisibleLayer.style.cursor = "inherit";
  }
};

export const onMouseDownMove = (
  e: React.MouseEvent<HTMLElement> | any,
  component: any,
  invisibleLayer: any,
  configName: string,
  config: WidgetConfig
) => {
  const checkMouseLeave = (e: MouseEvent) => {
    removeGuideLines(
      horizontalGuideLine,
      verticalGuideLine,
      horizontalGuideLineInfo,
      verticalGuideLineInfo
    );

    document.removeEventListener("mousemove", moveElement);
    document.removeEventListener("mouseout", checkMouseLeave);
  };

  // make invisible layer full width and height so that the cursor can
  // fly around the screen. otherwise it is limited to the area within
  // the element
  if (invisibleLayer) {
    invisibleLayer.style.width = "100%";
    invisibleLayer.style.height = "100%";
    invisibleLayer.style.left = "0px";
    invisibleLayer.style.top = "0px";
  }

  e.preventDefault();

  const elementBounds = component.getBoundingClientRect();

  // used so that element moves in relation to where cursor starts
  const shiftX = e.clientX - elementBounds.left;
  const shiftY = e.clientY - elementBounds.top;

  // We need to reference the parent bounds in case the parent is positioned separately
  // from the window
  const parentBounds = component.parentElement.getBoundingClientRect();

  const { horizontalGuideLine, verticalGuideLine } =
    createCornerGuidelines(component);
  const { horizontalGuideLineInfo, verticalGuideLineInfo } =
    createCornerGuidelineInfo(component);

  // tslint:disable-next-line: cyclomatic-complexity
  const moveElement = (e: MouseEvent) => {
    // const componentBounds = {
    //   top: e.pageY - shiftY,
    //   left: e.pageX - shiftX,
    //   bottom: e.pageY - shiftY + elementBounds.height,
    //   right: e.pageX - shiftX + elementBounds.width,
    // };
    // getCloseBounds(componentBounds, config, configName);
    // if the mouse moves outside of the widget borders then we need
    // to remove the listener or else the element can not be detached
    document.addEventListener("mouseout", checkMouseLeave);

    // we create the illusion that the configuration is being updated
    // but we don't update the actual widget config until mouseup
    if (e.shiftKey && (e.ctrlKey || e.metaKey)) {
      moveHorizontally(e, shiftX, parentBounds.left, component);
    } else if (e.shiftKey) {
      moveVertically(e, shiftY, parentBounds.top, component);
    } else {
      moveVertically(e, shiftY, parentBounds.top, component);
      moveHorizontally(e, shiftX, parentBounds.left, component);
    }

    if (component) {
      if (verticalGuideLine && horizontalGuideLine) {
        updateGuideLines(component, verticalGuideLine, horizontalGuideLine);
      }

      if (horizontalGuideLineInfo && verticalGuideLineInfo) {
        updateGuideLinesInfo(
          component,
          verticalGuideLineInfo,
          horizontalGuideLineInfo
        );
      }

      updateCornerBoxes(component);
    }
  };

  document.addEventListener("mousemove", moveElement);

  if (invisibleLayer) {
    // tslint:disable-next-line: cyclomatic-complexity
    invisibleLayer.onmouseup = (e2: MouseEvent) => {
      // removeRelativeBounds();
      sendMoveToMerchant(e2, configName, {
        // if modifier key is held then do not change left position
        left:
          (e.shiftKey
            ? elementBounds.left
            : e2.pageX - parentBounds.left - shiftX) + "px",
        // if modifier key is held then do not change top position
        top:
          (e.shiftKey && (e.ctrlKey || e.metaKey)
            ? elementBounds.top
            : e2.pageY - parentBounds.top - shiftY) + "px",
        height: component.style.height,
        width: component.style.width,
      });

      // bring invisible layer back to element size and position
      if (invisibleLayer) {
        invisibleLayer.style.width = elementBounds.width + 20 + "px";
        invisibleLayer.style.height = elementBounds.height + 20 + "px";
        invisibleLayer.style.left = e.shiftKey
          ? elementBounds.left + "px"
          : e2.pageX - shiftX - 10 + "px";
        invisibleLayer.style.top =
          e.shiftKey && (e.ctrlKey || e.metaKey)
            ? elementBounds.top - 10 + "px"
            : e2.pageY - shiftY - 10 + "px";
      }

      removeGuideLines(
        horizontalGuideLine,
        verticalGuideLine,
        horizontalGuideLineInfo,
        verticalGuideLineInfo
      );

      document.removeEventListener("mousemove", moveElement);
    };
  }
};

export const moveHorizontally = (
  e: React.MouseEvent<HTMLElement> | any,
  shiftX: number,
  parentLeft: number,
  component: any
) => {
  if (component) {
    component.style.left = e.pageX - parentLeft - shiftX + "px";
  }
};

export const moveVertically = (
  e: React.MouseEvent<HTMLElement> | any,
  shiftY: number,
  parentTop: number,
  component: any
) => {
  if (component) {
    component.style.top = e.pageY - parentTop - shiftY + "px";
  }
};
